<template>
    <div style="text-align:left">
        <Breadcrumb style="margin: 0px 10px 20px">
            <BreadcrumbItem to="/placementAdmin">版位管理</BreadcrumbItem>
            <BreadcrumbItem>查看数据统计</BreadcrumbItem>
        </Breadcrumb>
        <div class="statistics">
            <br>
            <Row>
                <Col span="8">
                    <div class="box">
                        <div class="title">                     
                            今天投放广告数
                        </div>
                        <div class="count">
                            {{ad_count}}
                        </div>
                    </div>
                </Col>
                <Col span="8">
                    <div class="box">
                        <div class="title">
                            今日曝光次数
                        </div>
                        <div class="count">
                            {{exposure_count}}次
                        </div>
                    </div>
                </Col>
                <Col span="8">
                    <div class="box">
                        <div class="title">
                            今日点击次数
                        </div>
                        <div class="count">
                            {{click_count}}次
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col span="8">
                    <div class="box">
                        <div class="title">                     
                            累计投放广告数
                        </div>
                        <div class="count">
                            {{total_ad_count}}
                        </div>
                    </div>
                </Col>
                <Col span="8">
                    <div class="box">
                        <div class="title">
                            累计曝光次数
                        </div>
                        <div class="count">
                            {{total_exposure_count}}次
                        </div>
                    </div>
                </Col>
                <Col span="8">
                    <div class="box">
                        <div class="title">
                            累计点击次数
                        </div>
                        <div class="count">
                            {{total_click_count}}次
                        </div>
                    </div>
                </Col>
            </Row>
            <Row class="row" style="margin-top:0px">
                <span style="line-height:40px">数据趋势</span>
            </Row>
            <Row class="row">
                <Col span="8">
                    <Select v-model="model" style="width:200px" @on-change="handleChange">
                        <Option value="show_count">曝光量</Option>
                        <Option value="click_count">点击数</Option>
                    </Select>
                </Col>
            </Row>
            <div id="echart"></div>
            <Table :columns="columns" :data="plans" style="margin:20px">
            </Table>
            <Page show-total :current="page" @on-change="changePage" style="margin-top: 10px; text-align: right" :total="total_count" :page-size="20"/>
            <br>
        </div>
    </div>
</template>

<script>
import Cookies from 'js-cookie';
import * as echarts from 'echarts';
import{placementData,placementPlanList}from "@/request/api"
export default {
    name: 'placementStatistics',
    components: {
        
    },
    data () {
        return {
            placement_id: '',
            ad_count: 0,
            exposure_count: 0,
            click_count: 0,
            total_ad_count: 0,
            total_exposure_count: 0,
            total_click_count: 0,
            model: 'show_count',
            exposure_count_list: [],
            click_connt_list: [],
            date_list: [],
            data: [],
            chart_name: '曝光量',
            columns: [
                {
                    title: '广告投放id',
                    key: 'plan_id',
                    align: 'center'
                },
                {
                    title: '广告名称',
                    key: 'title',
                    align: 'center'
                },
                {
                    title: '投放状态',
                    key: 'enable_flag',
                    align: 'center',
                    render: (h, { row } ) => {
                        if (row.status === '提前结束' || row.status === '已结束') {
                            return h('span', {
                            }, '已结束');
                        } else if (row.enable_flag === 1) {
                            return h('span', {
                            }, '投放中');
                        } else {
                            return h('span', {
                            }, '未投放');
                        }
                    },
                },
                {
                    title: '执行状态',
                    key: 'status',
                    align: 'center'
                },
                {
                    title: '投放日期',
                    key: 'plan_period',
                    align: 'center'
                },
                {
                    title: '实际投放天数',
                    key: 'actual_days',
                    align: 'center'
                },
                {
                    title: 'PV曝光次数',
                    key: 'exposure_count',
                    align: 'center'
                },
                {
                    title: '点击次数',
                    key: 'click_count',
                    align: 'center'
                },
                {
                    title: '操作',
                    slot: 'action',
                    align: 'center',
                    width: '150',
                    render: (h, params) => {
                        return h("div", [
                                h("Button", {
                                    props: {
                                        type: "text",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                        this.$router.push({
                                            name: "adDetail",
                                            query: {
                                                ad_id: params.row.ad_id,
                                            },
                                        });
                                        },
                                    },
                                },"查看广告详情"),
                                h("Button", {
                                    props: {
                                        type: "text",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                        this.$router.push({
                                            name: "planStatistics",
                                            query: {
                                                plan_id: params.row.plan_id,
                                            },
                                        });
                                        },
                                    },
                                },"投放数据统计")
                            ]
                        );
                    },
                }
            ],
            plans: [],
            total_count: 0,
            page: 1
        }
    },
    methods:{
        getPlacementPlanList(page, page_size, placement_id){
            placementPlanList({page, page_size, placement_id}).then(res=>{
                if(res.data.code==200){
                    this.plans=res.data.data.plans
                    this.page = page
                    this.total_count=res.data.data.total
                }
            })
        },
        getData(placement_id){
            placementData({placement_id}).then(res=>{
                if(res.data.code==200){
                    this.ad_count=res.data.data.statistics_data.ad_count
                    this.exposure_count=res.data.data.statistics_data.exposure_count
                    this.click_count=res.data.data.statistics_data.click_count
                    this.total_ad_count=res.data.data.statistics_data.total_ad_count
                    this.total_exposure_count=res.data.data.statistics_data.total_exposure_count
                    this.total_click_count=res.data.data.statistics_data.total_click_count
                    this.exposure_count_list=res.data.data.statistics_data.daily_flow_30.exposure
                    this.click_count_list=res.data.data.statistics_data.daily_flow_30.click
                    this.date_list=res.data.data.statistics_data.daily_flow_30.date
                    this.data=res.data.data.statistics_data.daily_flow_30.exposure
                    this.drawChart()
                }else{
                    this.$Message.success(res.data.msg);
                }
            })
        },
        drawChart(){
            var Echart = echarts.init(document.getElementById('echart'));
            var option1  = {
                xAxis: {
                    type: 'category',
                    data: this.date_list
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: this.data,
                    type: 'bar',
                    name: this.chart_name
                }],
                legend: {
                    show: true,
                    x:'center',
                    y:'bottom'
                },
                grid: {
                    top: 30
                },
                tooltip : {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                }
            };

            Echart.setOption(option1);
            window.addEventListener("resize", () => { Echart.resize();});
        },
        handleChange(value){
            if(value=='show_count'){
                this.chart_name = '曝光量'
                this.data = this.exposure_count_list
                this.drawChart()
            }else if(value=='click_count'){
                this.chart_name = '点击数'
                this.data = this.click_count_list
                this.drawChart()
            }
        },
        changePage(page){
            this.getPlacementPlanList(page,20,this.placement_id)
        }
    },
    created() {
        Cookies.set('active_name', '4');
        this.placement_id = this.$route.query.placement_id
        this.getData(this.placement_id)
        this.getPlacementPlanList(1,20,this.placement_id)
    },
    mounted(){
        Cookies.set('active_name', '4');
    }
}
</script>
<style scoped>
.banner{
  width: 100%;
  max-height: 120px;
  min-height: 120px;
  /* border:1px solid; */
  background: white;
}
.statistics{
  width: 100%;
  /* border:1px solid; */
  background: white;
  margin-top: 20px;
}
.row{
  margin: 10px 20px 10px;
}
.box{
  width: 200px;
  height: 120px;
  border:1px solid;
  margin: 0px 20px 20px;
}
.box .count{
  width: 100%;
  height: 70%;
  line-height: 60px;
  text-align: center;
  /* font-display: center; */
  font-size: 24px;
}
.box .title{
    text-align: left;
    font-size: 14px; 
    margin:10px 10px 0px;
}
#echart{
    margin:20px 20px 0px;
    width: 100%;
    height: 400px
}
</style>



// WEBPACK FOOTER //
// src/views/Placement/PlacementStatistics.vue